export const Form: any = {
  baseStyle: {
    requiredIndicator: { color: 'black', marginLeft: '0' },
  },
}
